<template>
  <b-form v-if="competition">

    <b-row class="text-right mb-2">
      <b-col>
        <b-button type="button" variant="secondary" size="sm" @click="cancel">Abbrechen</b-button>
        <b-button type="button" variant="danger" size="sm" @click="save">Speichern</b-button>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Name</b></b-col>
      <b-col cols="12" md="10">
        <b-form-input type="text" v-model="competition.name"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Veröffentlicht</b></b-col>
      <b-col cols="12" md="10">
        <b-form-select v-model="competition.public" :options="optionsTrueFalse"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Preise Veröffentlicht</b></b-col>
      <b-col cols="12" md="10">
        <b-form-select v-model="competition.prices" :options="optionsTrueFalse"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Kosten/Schüler</b></b-col>

      <b-col cols="6" md="2">
        <b-form-input v-model="competition.costs.price" />
      </b-col>

      <b-col cols="6" md="2">
        <b-form-select v-model="competition.costs.currency" :options="optionsCurrency"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Testquiz</b></b-col>
      <b-col cols="12" md="10">
        <select-competition class="mb-1"
          :competitions=this.testQuizOptions
          :competitionId=competition.testQuiz.id
          :allowNull=true
          v-on:change=setTestQuizId>
        </select-competition>

        <b-form-input v-if="competition.testQuiz.id" v-model="competition.testQuiz.token" placeholder="Zugangscode"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"></b-col>
      <b-col cols="6" md="5">
        Von:
      </b-col>
      <b-col cols="6" md="5">
        Bis:
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Anmeldung</b></b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.registration.start" type="date"/>
      </b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.registration.end" type="date"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Online</b></b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.online.start" type="date"/>
      </b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.online.end" type="date"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols=12 md=2><b>Papier</b></b-col>

      <template v-if="!hidePaper || !competition.paperDatesAsOnline()">
        <b-col cols=6 md=5>
          <b-form-input v-model="competition.dates.paper.start" type="date"/>
        </b-col>

        <b-col cols=6 md=5>
          <b-form-input v-model="competition.dates.paper.end" type="date"/>
        </b-col>

        <b-col cols=10 offset=2 md=10 class="mt-2">
          <b-form-checkbox v-model="hidePaper" @change="competition.copyOnlineDatesToPaper">Wie Online</b-form-checkbox>
        </b-col>
      </template>

      <template v-else>
        <b-col cols=10 offset=2 md=8 offset-md=0>
          <b-form-checkbox v-model="hidePaper">Wie Online</b-form-checkbox>
        </b-col>
      </template>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Transfer</b></b-col>
      <b-col cols="6" md="5"></b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.transfer" type="date"/>
      </b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col cols="12" md="2"><b>Zahlbar bis</b></b-col>
      <b-col cols="6" md="5"></b-col>
      <b-col cols="6" md="5">
        <b-form-input v-model="competition.dates.payment" type="date"/>
      </b-col>
    </b-row>

  </b-form>
</template>
<script>
import SelectCompetition from '@/components/competitions/admin/SelectCompetition'

require('moment')
export default {
  name: 'EditCompetitionDetails',
  components: {
    SelectCompetition
  },
  props: ['competition', 'competitions'],

  data: function () {
    return {
      hidePaper: true,
      optionsTrueFalse: [
        {value: false, text: 'nein'},
        {value: true, text: 'ja'}
      ],
      optionsCurrency: ['EUR', 'CHF']
    }
  },

  computed: {
    testQuizOptions: function () {
      let options = []
      this.competitions.forEach((c) => {
        if (c.value === this.competition.id) {
          return
        }

        options.push(c)
      })

      return options
    }
  },

  methods: {
    cancel: function () {
      this.$emit('cancel')
    },

    save: function () {
      this.competition.save()
        .then(() => {
          this.$emit('cancel')
        })

        .catch((err) => {
          this.$emit('error', err)
        })
    },

    setTestQuizId: function (id, name) {
      this.competition.testQuiz.id = id
      this.competition.testQuiz.name = name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/EditDetails.vue